module.exports = __webpack_public_path__ + "img/menuIcon8.31a6cd6c.png";